import { render } from "./InputValidationMessage.vue?vue&type=template&id=2b526ebc&scoped=true"
import script from "./InputValidationMessage.vue?vue&type=script&lang=js"
export * from "./InputValidationMessage.vue?vue&type=script&lang=js"

import "./InputValidationMessage.vue?vue&type=style&index=0&id=2b526ebc&lang=scss&scoped=true"

import exportComponent from "/var/www/recruitment-form-front-end-master/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b526ebc"]])

export default __exports__